var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchDoc"},[_c('div',{staticClass:"searchDoc__wrapper"},[_c('search',{on:{"selected":_vm.selected}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }